/* ===========================================================================
   FORMULÁRIOS DE PARCERIA
   máscara · validação por campo · envio para a planilha · tela de concluído
   ===========================================================================

   PARA ONDE VAI O ENVIO
   ---------------------------------------------------------------------------
   Para a planilha, pelo Apps Script, e mais nada. Destino único, sem reserva.

   Já foram dois destinos: a planilha e o formulário de contato nativo da
   Shopify, que manda o conteúdo para o e-mail da loja. O nativo existia porque
   um tema Liquid não tem servidor — era o único jeito de a página funcionar
   antes de haver planilha —, e depois ficou como rede de segurança.

   Ele saiu, e a marcação dele saiu junto. O motivo: o `{% form 'contact' %}`
   gera `action="/contact"` mais um `<input name="form_type" value="contact">`,
   e um script da própria plataforma procura esse par em toda página da loja.
   Achando, ele assume o envio — manda a pessoa para `/challenge`, o teste de
   robô da PLATAFORMA (que não é o hCaptcha de Loja virtual → Preferências, esse
   já estava desligado, e não tem botão no admin), e só então faz o POST. Que é
   o que dispara o e-mail da loja.

   NA PRIMEIRA TENTATIVA O CORTE FOI FEITO SÓ AQUI, com `preventDefault`. Não
   resolveu, e não tinha como resolver: quem faz o POST é o script da Shopify,
   por fora do evento. `preventDefault` cancela a ação padrão do NAVEGADOR, não
   o que outro script decide fazer. O conserto foi tirar da marcação o par que
   ele procura — hoje o `<form>` é cru, sem `action` e sem `form_type`, e o
   seletor dele não casa com nada.

   NÃO HÁ MAIS CAMINHO DE FALHA SILENCIOSO. Antes, se este script não rodasse, o
   envio nativo acontecia e o lead chegava por e-mail. Esse consolo era o próprio
   problema: e-mail é o destino que não se quer. Agora, quando o envio não sai, a
   pessoa VÊ — a caixa `.tp-form__falha` aparece com o e-mail da loja, e o
   formulário continua na tela com o que ela digitou. Ver `falhar()`.

   POR QUE NÃO BASTAVA O `required` DO HTML
   ---------------------------------------------------------------------------
   O navegador só sabe dizer "preencha este campo", numa bolha que aparece em
   UM campo por vez, some ao clicar em qualquer lugar, e não é estilizável. Num
   formulário de 14 campos em duas colunas isso significa: a pessoa envia, o
   navegador reclama do primeiro que achou, ela corrige, envia, reclama do
   próximo. Uma reclamação por tentativa.

   Aqui a validação roda em todos os campos de uma vez, escreve o erro embaixo
   de cada um, e rola até o primeiro. E o erro é específico: "CNPJ inválido"
   não é a mesma informação que "preencha este campo".

   POR QUE MÁSCARA, E NÃO SÓ VALIDAÇÃO
   ---------------------------------------------------------------------------
   `type="tel"` e `inputmode="numeric"` só SUGEREM o teclado numérico no
   celular. No desktop o campo continua aceitando letra, e no celular a pessoa
   pode trocar de teclado. Um telefone com letra dentro não é um telefone.

   A máscara resolve os dois lados de uma vez: filtra para dígito na entrada, e
   escreve os separadores no lugar certo. A pessoa digita 48992156537 e lê
   (48) 99215-6537 -- ela confere o próprio número no formato em que o conhece,
   que é a única forma de perceber que trocou um algarismo.

   O CURSOR
   ---------------------------------------------------------------------------
   Reescrever o valor de um input joga o cursor para o fim. Isso não incomoda
   quem está digitando no fim, e é insuportável para quem voltou ao meio para
   corrigir um dígito: cada tecla teleporta o cursor. Por isso `reposicionar`
   conta os DÍGITOS antes do cursor, reformata, e recoloca o cursor depois do
   mesmo número de dígitos -- não na mesma posição de caractere, que mudou.
   =========================================================================== */

(function () {
  'use strict';

  var MSG = {
    obrigatorio: 'Preencha este campo.',
    escolha: 'Escolha uma opção.',
    email: 'E-mail inválido. Confira se não falta o @ ou o ponto.',
    telCurto: 'Telefone incompleto. Informe o DDD e o número.',
    telDdd: 'DDD inexistente. Confira os dois primeiros números.',
    telCelular: 'Depois do DDD, celular começa com 9.',
    cnpjCurto: 'CNPJ incompleto. São 14 números.',
    cnpjInvalido: 'CNPJ inválido. Confira os números.'
  };

  /* DDDs que existem no Brasil. A lista importa: sem ela, "(00) 99999-9999"
     passa, e um telefone com DDD inventado é um lead que ninguém consegue
     ligar -- o erro só aparece semanas depois, na tentativa de contato. */
  var DDD = ('11 12 13 14 15 16 17 18 19 ' +
             '21 22 24 27 28 ' +
             '31 32 33 34 35 37 38 ' +
             '41 42 43 44 45 46 47 48 49 ' +
             '51 53 54 55 ' +
             '61 62 63 64 65 66 67 68 69 ' +
             '71 73 74 75 77 79 ' +
             '81 82 83 84 85 86 87 88 89 ' +
             '91 92 93 94 95 96 97 98 99').split(' ');

  function digitos(v) {
    return String(v || '').replace(/\D+/g, '');
  }

  /* ---------------------------------------------------------------- máscaras */

  function mascaraTelefone(v) {
    var d = digitos(v).slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : '';
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function mascaraCnpj(v) {
    var d = digitos(v).slice(0, 14);
    var s = d.slice(0, 2);
    if (d.length > 2) s += '.' + d.slice(2, 5);
    if (d.length > 5) s += '.' + d.slice(5, 8);
    if (d.length > 8) s += '/' + d.slice(8, 12);
    if (d.length > 12) s += '-' + d.slice(12, 14);
    return s;
  }

  var MASCARAS = {
    telefone: mascaraTelefone,
    cnpj: mascaraCnpj,
    digitos: function (v) { return digitos(v); }
  };

  /* Reescreve o valor mantendo o cursor sobre o MESMO dígito (ver comentário
     do topo). */
  function reposicionar(el, mascara) {
    var antes = el.value;
    var pos = el.selectionStart;
    var digitosAntesDoCursor = pos === null
      ? -1
      : digitos(antes.slice(0, pos)).length;

    var depois = mascara(antes);
    if (depois === antes) return;

    el.value = depois;

    if (digitosAntesDoCursor < 0) return;
    var novaPos = depois.length;
    var contados = 0;
    for (var i = 0; i < depois.length; i++) {
      if (/\d/.test(depois[i])) contados++;
      if (contados >= digitosAntesDoCursor) { novaPos = i + 1; break; }
    }
    try { el.setSelectionRange(novaPos, novaPos); } catch (e) { /* input sem seleção */ }
  }

  /* -------------------------------------------------------------- validações */

  function cnpjValido(d) {
    if (d.length !== 14) return false;
    /* 00000000000000, 11111111111111 etc. passam no cálculo dos dígitos
       verificadores mas não são CNPJ. É o valor que alguém digita para "pular"
       o campo, e é justamente o que não pode entrar. */
    if (/^(\d)\1{13}$/.test(d)) return false;

    function verificador(base) {
      var pesos = base.length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var soma = 0;
      for (var i = 0; i < base.length; i++) {
        soma += parseInt(base.charAt(i), 10) * pesos[i];
      }
      var resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    }

    if (verificador(d.slice(0, 12)) !== parseInt(d.charAt(12), 10)) return false;
    return verificador(d.slice(0, 13)) === parseInt(d.charAt(13), 10);
  }

  function erroTelefone(d) {
    if (d.length < 10) return MSG.telCurto;
    if (DDD.indexOf(d.slice(0, 2)) === -1) return MSG.telDdd;
    /* 11 dígitos = celular, e celular no Brasil tem o 9 na frente do número.
       Com 10 dígitos é fixo, que não tem essa regra. */
    if (d.length === 11 && d.charAt(2) !== '9') return MSG.telCelular;
    return '';
  }

  function erroEmail(v) {
    /* Deliberadamente mais frouxo que a RFC e mais rígido que o navegador: o
       Chrome aceita "a@b" como válido, e ninguém tem e-mail sem ponto no
       domínio. Exigir um ponto depois do @ pega o erro real (digitar
       "fulano@gmail" e enviar) sem recusar endereço legítimo esquisito. */
    return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v) ? '' : MSG.email;
  }

  /* Devolve a mensagem de erro do campo, ou '' se estiver bom. */
  function validar(el) {
    var obrigatorio = el.hasAttribute('required');
    var tipo = el.getAttribute('data-tp-valida') || '';
    var valor = (el.value || '').trim();

    if (el.tagName === 'SELECT') {
      return obrigatorio && !valor ? MSG.escolha : '';
    }

    if (!valor) return obrigatorio ? MSG.obrigatorio : '';

    if (tipo === 'email') return erroEmail(valor);

    if (tipo === 'telefone') return erroTelefone(digitos(valor));

    if (tipo === 'cnpj') {
      var d = digitos(valor);
      if (d.length < 14) return MSG.cnpjCurto;
      return cnpjValido(d) ? '' : MSG.cnpjInvalido;
    }

    return '';
  }

  /* --------------------------------------------------------------- interface */

  /* A caixa de erro e a do CONTEINER do campo, nao a apontada pelo
     aria-describedby: o describedby lista ajuda e erro juntos, e sair
     garimpando id ali exigia escapar seletor (o id tem `--` e digitos). O
     conteiner e um so e sempre tem no maximo uma caixa. */
  function caixaDeErro(el) {
    var campo = el.closest('.tp-form__campo');
    return campo ? campo.querySelector('.tp-form__erro') : null;
  }

  function mostrar(el, msg) {
    var caixa = caixaDeErro(el);
    var campo = el.closest('.tp-form__campo');

    if (msg) {
      el.setAttribute('aria-invalid', 'true');
      if (campo) campo.classList.add('tp-form__campo--erro');
      if (caixa) { caixa.textContent = msg; caixa.hidden = false; }
    } else {
      el.removeAttribute('aria-invalid');
      if (campo) campo.classList.remove('tp-form__campo--erro');
      if (caixa) { caixa.textContent = ''; caixa.hidden = true; }
    }
  }

  /* Num grupo de rádio a marca de erro é do GRUPO, não de cada pílula: o
     "required" está repetido em todos os inputs porque é assim que o HTML
     exige, mas a pessoa só precisa escolher um. */
  function grupos(form) {
    var mapa = {};
    Array.prototype.forEach.call(form.querySelectorAll('input[type="radio"][name]'), function (r) {
      (mapa[r.name] = mapa[r.name] || []).push(r);
    });
    return mapa;
  }

  /* ------------------------------------------------------------- envio */

  /* O QUE VAI PARA A PLANILHA.

     O rotulo humano vem de `data-tp-rotulo` e nao do `name`: o name do e-mail e
     `contact[email]`, exigencia da Shopify, e na planilha isso viraria uma
     coluna "email" em vez de "E-mail do contato". */
  function coletar(form) {
    var campos = {};
    var controles = form.querySelectorAll('[data-tp-rotulo]');
    for (var i = 0; i < controles.length; i++) {
      var el = controles[i];
      if (el.type === 'radio' && !el.checked) continue;
      var rotulo = el.getAttribute('data-tp-rotulo');
      var valor = (el.value || '').trim();
      if (!rotulo || !valor) continue;
      campos[rotulo] = valor;
    }
    return campos;
  }

  /* A PLANILHA E O DESTINO. Nao ha mais copia nem segundo caminho.

     `sendBeacon` primeiro: o navegador se compromete a entregar mesmo se a
     pessoa fechar a aba no mesmo instante, e por nao ler resposta nao dispara
     preflight de CORS -- e o que permite o Apps Script nao devolver cabecalho
     nenhum.

     `fetch` com `mode: 'no-cors'` como reserva, porque `sendBeacon` devolve
     false quando a fila do navegador esta cheia ou o corpo passa do limite. A
     resposta e opaca (nao da para ler status), mas a requisicao sai -- e sair e
     tudo o que importa aqui. `text/plain` de proposito: e um dos poucos tipos
     que `no-cors` aceita sem preflight.

     Devolve `true` se ALGUM dos dois foi disparado. `false` significa "nao
     tenho para onde mandar" -- endpoint, token ou nome do formulario faltando
     nos `data-` da secao, ou o corpo nao serializou.

     O chamador NAO tem plano B: ele mostra a caixa de falha (ver `falhar()`).
     Ja teve -- deixava o envio nativo da Shopify acontecer -- e era esse plano B
     que levava ao `/challenge` e ao e-mail da loja. */
  function paraPlanilha(raiz, form) {
    var endpoint = raiz.getAttribute('data-tp-endpoint');
    var token = raiz.getAttribute('data-tp-token');
    var formulario = raiz.getAttribute('data-tp-formulario');
    if (!endpoint || !token || !formulario) return false;

    var corpo;
    try {
      var isca = form.querySelector('[name="tp_isca"]');
      corpo = JSON.stringify({
        token: token,
        formulario: formulario,
        isca: isca ? isca.value : '',
        campos: coletar(form),
        pagina: location.pathname,
        utm: location.search.replace(/^\?/, ''),
        dispositivo: navigator.userAgent
      });
    } catch (e) {
      return false;
    }

    var tipo = { type: 'text/plain;charset=UTF-8' };

    try {
      if (navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([corpo], tipo))) {
        return true;
      }
    } catch (e) { /* cai na reserva */ }

    try {
      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: corpo,
        keepalive: true
      })['catch'](function () { /* opaca de qualquer forma */ });
      return true;
    } catch (e) {
      return false;
    }
  }

  /* O ENVIO NAO SAIU, E A PESSOA PRECISA SABER.

     Esta e a contrapartida de ter destino unico. Enquanto o envio nativo da
     Shopify existia como reserva, falhar aqui era quase inofensivo: o lead ia
     por e-mail. Sem reserva, uma falha silenciosa e um lead que desaparece com
     a pessoa achando que se cadastrou.

     O formulario CONTINUA na tela, preenchido. Nada de trocar pelo painel de
     concluido, e nada de limpar campo: o unico caminho que resta e ela tentar
     de novo ou copiar o que escreveu, e as duas coisas exigem o texto ali.

     O texto da caixa vem do Liquid (ver a secao) -- aqui so se tira o `hidden`. */
  function falhar(raiz) {
    var caixa = raiz.querySelector('.tp-form__falha');
    if (!caixa) return;

    caixa.hidden = false;

    /* Rolar ate a caixa, e nao ate o topo: o botao de enviar fica no FIM de um
       formulario de 14 campos, e a caixa esta logo acima dos campos. Sem isto a
       pessoa aperta "enviar", nada visivel muda, e a unica explicacao esta a uma
       tela de distancia. */
    caixa.scrollIntoView({ behavior: 'smooth', block: 'center' });

    /* `role="alert"` ja faz o leitor de tela anunciar. O `tabindex` e o foco sao
       para quem enxerga e navega por teclado nao ter de voltar procurando. */
    caixa.setAttribute('tabindex', '-1');
    try { caixa.focus({ preventScroll: true }); } catch (e) { /* navegador antigo */ }
  }

  function esconderFalha(raiz) {
    var caixa = raiz.querySelector('.tp-form__falha');
    if (caixa) caixa.hidden = true;
  }

  /* Troca a pagina pela confirmacao, sem recarregar. */
  function concluir(raiz) {
    var painel = raiz.querySelector('.tp-form__ok[hidden]');
    if (!painel) return false;

    var hero = raiz.querySelector('.tp-form__hero');
    var cartao = raiz.querySelector('.tp-form__card');
    if (hero) hero.hidden = true;
    if (cartao) cartao.hidden = true;
    painel.hidden = false;

    /* A URL passa a dizer o que a tela diz. Sem isto, atualizar a pagina traria
       o formulario vazio de volta como se nada tivesse acontecido.

       Quem le esta marca de volta e o `telaDeConcluido()`, aqui mesmo. Antes era
       a Shopify: `contact_posted=true` era o retorno do envio nativo, e o Liquid
       renderizava a confirmacao sozinho. Esse caminho nao existe mais, entao a
       marca so vale porque o proprio script a interpreta na carga seguinte. */
    try {
      history.replaceState({}, '', location.pathname + '?contact_posted=true');
    } catch (e) { /* navegador antigo */ }

    subirEFocar(painel);
    return true;
  }

  function iniciar(raiz) {
    var form = raiz.querySelector('form');
    if (!form) return;

    var controles = Array.prototype.slice.call(
      form.querySelectorAll('input[data-tp-rotulo], select[data-tp-rotulo], textarea[data-tp-rotulo]')
    ).filter(function (el) { return el.type !== 'radio'; });

    /* ---- máscara enquanto digita ---- */
    controles.forEach(function (el) {
      var mascara = MASCARAS[el.getAttribute('data-tp-valida')];
      if (!mascara) return;
      el.addEventListener('input', function () { reposicionar(el, mascara); });
      /* Colar cai no evento `paste` antes do `input`; deixar o `input` cuidar
         evita ler o clipboard e funciona igual em todo navegador. */
    });

    /* ---- erro só depois do primeiro contato ---- */
    controles.forEach(function (el) {
      el.addEventListener('blur', function () {
        el.dataset.tpTocado = '1';
        mostrar(el, validar(el));
      });
      /* Enquanto ela corrige, o erro sai na hora em que fica válido -- e não
         só no próximo blur. Nunca APARECE durante a digitação, o que seria
         reclamar de um campo que ela ainda está preenchendo. */
      el.addEventListener('input', function () {
        if (el.dataset.tpTocado && el.getAttribute('aria-invalid')) {
          mostrar(el, validar(el));
        }
      });
    });

    var porGrupo = grupos(form);
    Object.keys(porGrupo).forEach(function (nome) {
      porGrupo[nome].forEach(function (r) {
        r.addEventListener('change', function () {
          mostrar(porGrupo[nome][0], '');
        });
      });
    });

    /* ---- envio ---- */
    form.addEventListener('submit', function (ev) {
      var primeiro = null;

      controles.forEach(function (el) {
        var msg = validar(el);
        el.dataset.tpTocado = '1';
        mostrar(el, msg);
        if (msg && !primeiro) primeiro = el;
      });

      Object.keys(porGrupo).forEach(function (nome) {
        var grupo = porGrupo[nome];
        var exigido = grupo.some(function (r) { return r.hasAttribute('required'); });
        var marcado = grupo.some(function (r) { return r.checked; });
        var msg = exigido && !marcado ? MSG.escolha : '';
        mostrar(grupo[0], msg);
        if (msg && !primeiro) primeiro = grupo[0];
      });

      /* `preventDefault` INCONDICIONAL, e antes de qualquer decisao.

         Ele ficava la embaixo, condicionado a "o envio deu certo E ha painel
         para mostrar". Faltando qualquer uma das duas, o envio nativo rodava
         como reserva -- e essa reserva era exatamente o `/challenge` e o e-mail
         da loja, os dois problemas que este arquivo existe para evitar.

         Hoje o `<form>` nem tem `action` para onde submeter (ver o topo). Este
         `preventDefault` e a segunda das duas travas, nao a unica: uma no HTML,
         outra aqui. Nenhuma delas depende do envio ter dado certo. */
      ev.preventDefault();

      if (primeiro) {
        /* Rolar E focar. Só focar já rola, mas encosta o campo no topo da
           viewport, atrás do cabeçalho fixo; `scrollIntoView` com 'center' deixa
           o campo e a mensagem visíveis juntos. O foco vem depois, com
           preventScroll, para não desfazer o enquadramento. */
        var campo = primeiro.closest('.tp-form__campo') || primeiro;
        campo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { primeiro.focus({ preventScroll: true }); } catch (e) { primeiro.focus(); }
        return;
      }

      /* PASSOU. A planilha e o destino, e so ela.

         A caixa de falha e limpa ANTES da tentativa: se a pessoa ja tinha visto
         o erro e esta tentando de novo, deixar a mensagem antiga na tela
         enquanto a nova tentativa acontece diz a coisa errada. */
      esconderFalha(raiz);

      if (paraPlanilha(raiz, form) && concluir(raiz)) return;

      falhar(raiz);
    });

    /* `novalidate` POR ULTIMO, e nao no inicio.

       Ele desliga a validacao do navegador -- que e o que evita mostrar a bolha
       nativa E o erro escrito embaixo dizendo a mesma coisa. So que desligar e
       um ato de confianca: quem valida a partir dali sou eu.

       Se esta funcao estourasse no meio (um seletor que nao existe, um campo com
       formato inesperado), com o `novalidate` la em cima o formulario ficaria
       SEM validacao nenhuma: a nativa desligada e a minha nunca instalada.
       Aqui embaixo, so desligo a nativa depois que o meu `submit` esta de fato
       escutando. Estourar antes disto agora significa cair de volta na validacao
       do navegador, que e feia mas funciona. */
    form.setAttribute('novalidate', 'novalidate');
  }

  /* Sobe a pagina e leva o foco para a confirmacao.

     A subida e FORCADA e repetida por causa da RECARGA: quem atualiza a pagina
     depois de enviar tem a rolagem restaurada pelo navegador, e essa restauracao
     acontece depois do DOMContentLoaded -- subir uma vez so nao resolve, porque
     o navegador desce de volta em seguida. Tres tentativas cobrem o caso.

     A guarda `mexeu` desiste na hora em que a pessoa rola por conta propria --
     puxar a pagina de volta enquanto alguem le e pior que o problema original.

     O foco tem de sair do formulario: sem isto ele fica no <body> e quem navega
     por teclado recomeca do topo do site. `preventScroll` para o foco nao
     desfazer a subida. O `role="status"` do painel ja faz o leitor de tela
     anunciar o texto. */
  function subirEFocar(painel) {
    var mexeu = false;
    var desiste = function () { mexeu = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, desiste, { passive: true, once: true });
    });

    var subir = function () { if (!mexeu) window.scrollTo(0, 0); };
    subir();
    requestAnimationFrame(subir);
    setTimeout(subir, 120);

    painel.setAttribute('tabindex', '-1');
    try { painel.focus({ preventScroll: true }); } catch (e) { /* navegador antigo */ }
  }

  /* ------------------------------------------------------ tela de concluido */

  /* QUEM ATUALIZA A PAGINA DEPOIS DE ENVIAR CONTINUA TENDO ENVIADO.

     O envio nao recarrega nada, entao a confirmacao mora so na memoria da aba:
     um F5 traria o formulario vazio de volta, como se nada tivesse acontecido.
     E o `concluir()` deixa `?contact_posted=true` na URL justamente para este
     momento -- alguem tem de ler a marca na carga seguinte, e esse alguem passou
     a ser este script.

     Antes era a Shopify: `contact_posted=true` era o retorno do envio nativo, e
     o Liquid ja renderizava a confirmacao. Com o envio nativo fora (ver o topo),
     a marca ficaria escrita na URL sem ninguem para interpretar.

     NAO se reenvia nada aqui. A marca diz "isto ja foi enviado", e reenviar em
     cada F5 encheria a planilha de linhas repetidas do mesmo lead. */
  function telaDeConcluido() {
    /* O `:not([hidden])` cobre um painel que ja tenha sido revelado por outro
       caminho; a marca na URL cobre a recarga. */
    var painel = document.querySelector('.tp-form__ok:not([hidden])');

    if (!painel && /(^|[?&])contact_posted=true(&|$)/.test(location.search)) {
      var raiz = document.querySelector('.tp-form');
      if (raiz) {
        painel = raiz.querySelector('.tp-form__ok[hidden]');
        if (painel) {
          var hero = raiz.querySelector('.tp-form__hero');
          var cartao = raiz.querySelector('.tp-form__card');
          if (hero) hero.hidden = true;
          if (cartao) cartao.hidden = true;
          painel.hidden = false;
        }
      }
    }

    if (!painel) return;

    subirEFocar(painel);
  }

  function tudo() {
    Array.prototype.forEach.call(document.querySelectorAll('.tp-form'), iniciar);
    telaDeConcluido();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tudo);
  } else {
    tudo();
  }
})();
